export default "__VITE_ASSET__b95775d8__"